import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation, Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import DailyDeviationIndicator from '@wix/da-ds/pkg/Indicators/DailyDeviationIndicator';
import DeviationFlag from '@wix/da-ds/pkg/Indicators/DeviationFlag';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { formatDate, DATE_FORMATS } from '@wix/da-ds/pkg/Time/functions';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import UserLink from '../../../User/Link/UserLink';
import LegacyTextRenderer from '../../../TextRenderer/LegacyTextRenderer';
import deviationFlagStyles from './DeviationFlags.scss';
const DailyDeviationCard = ({ dailyDeviation: { body, time, giver, suggester } })=>{
    const { t } = useTranslation();
    const { isLoggedIn } = useContext(SessionContext);
    const complete_theme = useFlag('complete_theme');
    const dd_and_hype_banners = useFlag('dd_and_hype_banners');
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        className: classnames(deviationFlagStyles['flag-block'], deviationFlagStyles['open']),
        // can tear out the override when merging complete_theme
        theme: complete_theme ? 'match' : ThemeOptions.LIGHT,
        tag: "div"
    }, dd_and_hype_banners ? /*#__PURE__*/ React.createElement(DeviationFlag, {
        variant: "daily-deviation",
        size: "large",
        className: deviationFlagStyles['flag']
    }) : /*#__PURE__*/ React.createElement(DailyDeviationIndicator, {
        className: deviationFlagStyles['flag'],
        size: "large"
    }), /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['content']
    }, /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['title']
    }, t('actionbar.flags.dailyDeviation')), /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['open-only']
    }, /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['time'],
        suppressHydrationWarning: true
    }, t('actionbar.flags.givenOn', {
        date: formatDate(time, DATE_FORMATS.Date.Full)
    })), /*#__PURE__*/ React.createElement(LegacyTextRenderer, {
        className: deviationFlagStyles['body'],
        html: body
    }), /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['attribution']
    }, /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['giver']
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "actionbar.flags.featuredBy"
    }, "Featured by ", /*#__PURE__*/ React.createElement(UserLink, {
        user: giver,
        className: deviationFlagStyles['link']
    }))), suggester && /*#__PURE__*/ React.createElement("div", {
        className: deviationFlagStyles['suggester']
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "actionbar.flags.suggestedBy"
    }, "Suggested by ", /*#__PURE__*/ React.createElement(UserLink, {
        user: suggester,
        className: deviationFlagStyles['link']
    })))), isLoggedIn && /*#__PURE__*/ React.createElement(TextButton, {
        href: Url.browseDailyDeviationsLink(),
        size: "medium",
        variant: "approval-green",
        noHorizontalPaddings: true
    }, t('actionbar.flags.seeAll')))));
};
DailyDeviationCard.displayName = 'DailyDeviationCard';
export default DailyDeviationCard;
